<template>
  <div class="app-container">
    <BjRouteTabs />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingBaseDataAfterSalesReason.table.code')" prop="reasonCode">
            <BjInput
              v-model="queryParams.reasonCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingBaseDataAfterSalesReason.table.description')" prop="reasonDescribe">
            <BjInput
              v-model="queryParams.reasonDescribe"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="status">
            <BjSelectLov v-model="queryParams.status" :option-list="STATUS_ENABLED_NUM" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingBaseDataAfterSalesReason.table.isUse')" prop="useFlag">
            <BjSelectLov v-model="queryParams.useFlag" :option-list="USE_FLAG_NUM" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <!-- <el-button
            v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Delete
            type="primary"
            :disabled="tableOperationProp.notSelected"
            @click="onDeleteSelected"
             class='delete-btn'>{{ $t('delText') }}</el-button
          > -->
          <el-button
            v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('SettingBaseDataAfterSalesReason.table.newAfterSales') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <el-tag
                v-else-if="col.prop === 'status'"
                :type="scope.row.status ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_NUM.bjGet(scope.row.status)) }}</el-tag
              >

              <el-tag
                v-else-if="col.prop === 'useFlag'"
                :type="scope.row.useFlag ? 'success' : 'info'"
                >{{ $t(USE_FLAG_NUM.bjGet(scope.row.useFlag)) }}</el-tag
              >
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Edit
                :disabled="!!props.row.useFlag"
                type="text"
                class="edit-btn"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-if="props.row.status"
                v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Status
                type="text"
                @click="onStatus(0, props.row)"
                >{{ $t('disableText') }}</el-button
              >
              <el-button
                v-if="!props.row.status"
                v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Status
                type="text"
                @click="onStatus(1, props.row)"
                >{{ $t('enableText') }}</el-button
              >
              <el-button
                v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Delete
                :disabled="!!props.row.useFlag"
                type="text"
                class="delete-btn"
                @click="onDelete(props.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { baseDataApi } from '@/api';
import { STATUS_ENABLED_NUM, USE_FLAG_NUM } from '@/utils/constants';
import DataForm from './components/DataForm.vue';

const DEFAULT_TYPE = 0; // 原因类型 0仅退款 1退货退款
export default {
  name: 'SettingBaseDataAfterSalesReasonRefundIndex',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      STATUS_ENABLED_NUM,
      USE_FLAG_NUM,
      queryApi: baseDataApi.getAfterSalesReasons,
      // 查询参数
      queryParams: {
        reasonCode: null,
        reasonDescribe: null,
        status: null,
        useFlag: null,
        type: DEFAULT_TYPE,
      },

      labelsVersion: 11,
      labelList: [
        { label: 'SettingBaseDataAfterSalesReason.table.code', prop: 'reasonCode', isCheck: true, disabled: false },
        { label: 'SettingBaseDataAfterSalesReason.table.description', prop: 'reasonDescribe', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
        { label: 'SettingBaseDataAfterSalesReason.table.isUse', prop: 'useFlag', isCheck: true, disabled: false }, // 使用状态 0未使用 1已使用 ,
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      selectedRow: null,
    };
  },
  watch: {},
  methods: {
    /** 新增售后原因 */
    onAdd() {
      this.$refs.DataForm.show({ type: DEFAULT_TYPE });
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
      // baseDataApi.detailAfterSalesReasons({ id: row.id }).then(res => {
      //   if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
      //     this.$refs.DataForm.show(this.$lodash.clone(res));
      //   }
      // });
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_NUM.bjGet(flag));
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${this.$t('SettingBaseDataAfterSalesReason.confirmText')}（${row.reasonDescribe}），${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: row.id,
            status: flag,
            objectVersionNumber: row.objectVersionNumber,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${this.$t('SettingBaseDataAfterSalesReason.confirmText')}（${row.reasonDescribe}），${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.deleteApi({
            id: row.id,
            objectVersionNumber: row.objectVersionNumber,
          });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => e.useFlag == 1)) {
        this.$message.warning(this.$t('SettingBaseDataAfterSalesReason.msgWarning'));
        return;
      }

      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    /* 关闭弹窗 */
    handleClose() {
      this.setDialogVisible = false;
    },

    operationApi(API_DATA) {
      baseDataApi.updateAfterSalesReasons(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    deleteApi(API_DATA) {
      baseDataApi.deleteAfterSalesReasons(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      baseDataApi.batchDeleteAfterSalesReasons(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    reFresh() {
      this.$store.dispatch('values/getAfterRefundOnlyReasons', true);
      this.$refs.BjPage && this.$refs.BjPage.fetchData();
    },
  },
};
</script>
